import Highlighter from './Highlighter';

export default Highlighter;
